( function ( $ ) {
	const landingLink = $( '.landing-explore' );
	const landingOverlay = $('#landing');

	landingLink.click( function ( e ) {
		e.preventDefault();
		landingOverlay.addClass('hide');
	});
} )( jQuery );
